import React from 'react';
import './selectBox.less';
import $ from 'jquery';

class MySelectBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectData: props.selectData ? props.selectData : [],
            tempData:[],
            selectTitle:  props.selectTitle ? props.selectTitle : '请选择',
            isShowSelect: false,
            searchValue: '',
            width: props.width ? props.width : 150,
            height: props.height ? props.height : 26,
            idName: props.idName ? props.idName : (new Date().getTime()),
            onchange: props.onchange,
            onchangecheck:props.onchangecheck,
            searchKeyword:props.searchKeyword,
        };
    }
    componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。
        let selectData = this.state.selectData;
        let selectTitle = this.state.selectTitle;
        selectData.map((item, i) => {
            if (item.isSelect) {
                selectTitle = item.title;
            }
        })
        this.setState({ selectTitle });
        document.onclick=this.listentClickDocument;
    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        if (props.selectData != this.state.selectData) {
            let selectData = props.selectData ? props.selectData : [];
            let selectTitle =  props.selectTitle ? props.selectTitle : '请选择';

            if (selectData.length > 0) {
                selectData.forEach((item) => {
                    if (item.isSelect) {
                        selectTitle = item.title
                    }
                })
            }
            selectData.forEach((item, i) => {
                item.isShow = true;
            })
            this.state = {
                selectData,
                selectTitle,
                idName:props.idName ? props.idName:(new Date().getTime()),
                onchange:props.onchange,
                onchangecheck:props.onchangecheck,
                searchKeyword:props.searchKeyword,
            };
        }

    }
    listentClickDocument = () => {
        $('.mySelectBoxWrap').find(".icon-xiangxia").removeClass('active');
        $(".mySelectBoxWrap-content").addClass('hide');
        this.setState({ isShowSelect: false, searchValue: '' });
    }
    stopM = (e) => {
        e.nativeEvent.stopImmediatePropagation();
    }
    chooseItem = (index) => {
        let selectData = this.state.selectData;
        let selectTitle = '';
        let selectObj = {};
        let idName = this.state.idName;

        var current = selectData[index];
        if(typeof this.state.onchangecheck == 'function'){
            let resultData={};
            resultData.idName=idName;
            resultData.selectObj=current;
            if(!this.state.onchangecheck(resultData))
                return;
        }

        selectData.forEach((item, i) => {
            if (i == index) {
                item.isSelect = !item.isSelect;
                if (item.isSelect) {
                    selectObj = item;
                    selectTitle = item.title;
                } else {
                    selectObj = {};
                }
            } else {
                item.isSelect = false;
            }
        })
        
        this.setState({ selectData, isShowSelect: false, selectObj,selectTitle },()=>{
            if (typeof this.state.onchange == "function") {
                let resultData={};
                resultData.idName=idName;
                resultData.selectObj=selectObj;
                this.state.onchange(resultData);  //传给父组件的选中 数据
            }

        })
    }
    showSelect = (e) => {
        this.listentClickDocument()
        e.nativeEvent.stopImmediatePropagation();
        console.log(e)
        console.log(e.target)
        
        $(e.target).closest('.mySelectBoxWrap').find(".mySelectBoxWrap-content").removeClass('hide');
        $(e.target).closest('.mySelectBoxWrap').find(".icon-xiangxia").addClass('active');
        let selectData = this.state.selectData;
        selectData.forEach((item) => {
            item.isShow = true;
        })
        this.setState({ isShowSelect: true, selectData, searchValue: '' })
    }
    changeForm = (e) => {
        let value = e.target.value.trim();
        this.state.searchValue = value;
        this.setState({ })
        if(typeof this.state.searchKeyword == 'function'){
            this.state.searchKeyword(value)
            return;
        }

        let selectData = this.state.selectData;
        selectData.forEach((item, i) => {
            if (item.title.indexOf(value) != -1) {
                item.isShow = true;
            } else {
                item.isShow = false;
            }
        })
        this.setState({ selectData, searchValue: value });
    }

    render() {
        const { selectData, searchValue, isShowSelect, selectTitle, width, height } = this.state;
        let elems =
            <div className='mySelectBoxWrap'>
                <div className="mySelectBoxWrap-title" onClick={(e) => this.showSelect(e)} style={{ width: width + 'px', height: height + 'px' }}>
                    <div className="mySelectBoxWrap-title-left">{selectTitle}</div>
                    <i className='iconfont icon-xiangxia'></i>
                </div>


                <div className='mySelectBoxWrap-content hide'>
                    <div className="mySelectBoxWrap-search" onClick={(e) => this.stopM(e)}>
                        <input className='mySelectBoxWrap-search-left-input' placeholder='请输入搜索内容' value={searchValue} onChange={(e) => this.changeForm(e)}></input>
                        <span className='iconfont icon-sousuo'></span>
                    </div>
                    <ul className='mySelectBoxWrap-main'>
                        {
                            selectData.map((item, index) =>

                                item.isShow ?
                                    <li className={item.isSelect ? "active" : ''} onClick={() => this.chooseItem(index)}>{item.title}</li> : null

                            )
                        }
                        {
                            selectData.length == 0 ?
                                <li style={{ justifyContent: 'center' }}>暂无数据！</li> : null
                        }
                    </ul>
                </div>
            </div>
        return (
            elems
        );
    }
}

export default MySelectBox;



// WEBPACK FOOTER //
// ./src/components/selectBox/index.jsx